"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getQueryStringParams(url, paramToLowerCase) {
    if (paramToLowerCase === void 0) { paramToLowerCase = false; }
    url = url || window.location.href;
    var args = (url.split('?')[1] || '').split('&');
    var params = {};
    args.forEach(function (arg) {
        var argParts = arg.split('=');
        var value = '';
        if (argParts.length === 2) {
            value = decodeURIComponent(argParts[1].replace(/\+/g, ' '));
        }
        var param = paramToLowerCase ? argParts[0].toLowerCase() : argParts[0];
        params[param] = value;
    });
    return params;
}
exports.getQueryStringParams = getQueryStringParams;
